export default __webpack_public_path__ + "static/media/Rectangle 148463.12cc3a21.png";